<template>
    <div v-html="value || placeholder"></div>
</template>

<script>

export default {
    props: {
        value: {
            type: String,
        },
        placeholder: {
            type: String,
            default: '--'
        },
    },
    data() {
        return {};
    }
};
</script>
